export default class DraggableStateModel {
  constructor(
    public id: string,
    public x: number,
    public y: number,
  ) {}
}
